import React from 'react';
import { useSelector } from 'react-redux';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useTrackPageView, useTrackCampaignsImpression } from '@browsing/tracking';
import type { EcommerceCreativeName, ItemSchema } from '@pegasus/tracker';
import { Campaign } from '@shared/types/mylounge';
import { getIsMobileScreen } from '@client/redux/modules/clientDevice/selectors';
import { getCategoryTabId } from '@client/redux/modules/mylounge';
import { getTrackingData } from '@client/redux/modules/tracking/selectors';
import { useMylounge } from '@client/components/mylounge/hooks';
import { CustomCampaignsList } from './customCampaignsList';

export type CustomCampaignsConfig = {
    campaigns: Campaign[];
    page: 'new_deals' | 'ending_soon_deals';
    translationScope: string;
    viewTestId: string;
    idPrefix: string;
    trackCreativeName: EcommerceCreativeName;
    trackItemListName: ItemSchema['item_list_name'];
};

type Props = {
    config: CustomCampaignsConfig;
};

export const CustomCampaignsView: React.FC<Props> = ({ config }) => {
    useMylounge();
    const isMobileScreen = useSelector(getIsMobileScreen);
    const categoryTabId = useSelector(getCategoryTabId);
    const tracking = useSelector(getTrackingData);
    const hasCampaigns = config.campaigns?.length > 0;

    useTrackPageView({ page: config.page, isLoaded: hasCampaigns });
    useTrackCampaignsImpression({ categoryTabId, isMobileScreen, visitorID: tracking?.visitorID });

    return (
        <TranslateScope path="myLounge">
            <CustomCampaignsList
                campaigns={config.campaigns}
                title={
                    <TranslateScope path={config.translationScope}>
                        <Translate message="viewTitle" raw />
                    </TranslateScope>
                }
                breadcrumbLabel={
                    <TranslateScope path={config.translationScope}>
                        <Translate message="backBreadcrumb" raw />
                    </TranslateScope>
                }
                viewTestId={config.viewTestId}
                idPrefix={config.idPrefix}
                trackCreativeName={config.trackCreativeName}
                trackItemListName={config.trackItemListName}
            />
        </TranslateScope>
    );
};
